/**
 * Routing control module
 */
import { requestData } from '../utils'
import RoutingRuleRequest from './RoutingRuleRequest'
import RoutingRule from './RoutingRule'

export default class RoutingModule {
  queryRoutingRules(query, abortSignal) {
    const routingRuleRequest = new RoutingRuleRequest(query)
    return requestData(
      'GET',
      `/provisioning/query/mt-routing-rules`,
      routingRuleRequest,
      undefined,
      abortSignal,
    )
  }
  getRoutingRules(params, abortSignal) {
    const routingRuleRequest = new RoutingRule(params)
    return requestData(
      'GET',
      `/provisioning/mt-routing-rules`,
      routingRuleRequest,
      undefined,
      abortSignal,
    )
  }
  addRoutingRule(params, abortSignal) {
    // const routingRuleRequest = new RoutingRule(params)
    return requestData(
      'POST',
      `/provisioning/mt-routing-rules`,
      params,
      undefined,
      abortSignal,
    )
  }
  getRoute(params, abortSignal) {
    return requestData(
      'GET',
      `/routing/route-mt`,
      params,
      undefined,
      abortSignal,
    )
  }
}
